import {
    apiRequest,
    templateSuratList,
    templateSuratDelete
} from "../../../../../services/adapters/master/templateSuratService.jsx"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", templateSuratList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchDelete = async (query) => {
        return await apiRequest("post", templateSuratDelete, {
            body: query
        }, true)
    }
}

export default DataTableRepository
